import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import * as actions from "../../actions";

import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';


import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';



const style = theme => ({

  ///// TOOL BAR TOP STYLE


  toolBarTopFixed:{
    position: "fixed",
    display: "flex",
    height: 40,

    width: "100%",
    top: 0,
    left: 0,
    justifyContent: "flex-end",
    backgroundImage: "url('https://i.imgur.com/JtCveG3.jpg')",
    backgroundSize: "cover",
    zIndex: 3000,
    boxShadow: theme.shadows[5]
  },

  toolBarTopContainer:{
    position: "relative",

  },

  loginButton:{
    position: "relative",
    height: 40,
    textAlign: "left",
    fontSize: 15,
    paddingLeft: 16,
    paddingRight: 16,
    fontWeight:"bold",
    borderRadius: 0,

  },
  button:{
    height: 40,
    fontSize: 15,

  },
  userMenu:{
    marginLeft: -16,
    marginTop: 10,
    width: 200 ,

    background:  theme.palette.background.gold,

    borderRadius: 2,
  },
  userMenuItem:{

    fontSize: 12,
    height: 20,
    textTransform: "uppercase",

  }
})

class NavTopFixedBar extends React.Component {
  state = {

    anchorEl: null,
    navIsFixed: false,

    premiumBetsData: this.props.premiumBetsData,
    activeBetsNum: 0,
  };

  static contextTypes = {
    router: PropTypes.object
  }

  componentDidUpdate(prevProps){


  }

  goToUserPanel = ()=>{
    this.context.router.history.push("/mojestave")
  }

  goToControlPanel = ()=>{
    this.context.router.history.push("/controlpanel")
  }

  handleChange = (event, checked) => {
    this.setState({ auth: checked });
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleLogOut = () => {
    this.props.signOut()
    this.setState({ anchorEl: null });
  }

  login = ()=>{
    this.props.loginDialogState(true)
  }

  render() {
    const { classes, auth, } = this.props;



    return (
      <Hidden smDown>
        <div className={classes.toolBarTopFixed}>

            <Grid container style={{display:"flex"}} justify="center">
              <Grid item xs={12} >
                {auth ? (
                    <div className={classes.toolBarTopContainer}>
                      <Button

                        classes={{root:classes.loginButton}}
                      >
                          {auth.displayName ? auth.displayName: auth.email}

                      </Button>


                      {
                        (auth.admin || auth.mod) ? (
                          <span>
                            <span style={{borderRight: "1px solid gray", borderColor: this.props.theme.palette.primary.main}}></span>
                            <Button className={classes.button} color="primary" onClick={this.goToControlPanel}>
                              Nadzorna plosca
                            </Button>
                            <span style={{borderRight: "1px solid gray", borderColor: this.props.theme.palette.primary.main}}></span>
                            <Button className={classes.button} color="primary" onClick={this.handleLogOut}>
                              Odjava
                            </Button>
                          </span>
                        ):(
                          <span>
                            <span style={{borderRight: "1px solid gray", borderColor: this.props.theme.palette.primary.main}}></span>
                            <Button className={classes.button} color="primary"  onClick={()=>this.context.router.history.push("/mojestave")}>
                              Stave
                            </Button>
                            <span style={{borderRight: "1px solid gray", borderColor: this.props.theme.palette.primary.main}}></span>
                            <Button className={classes.button} color="primary" onClick={()=>this.context.router.history.push("/narocilo")}>
                              Ponudba
                            </Button>
                            <span style={{borderRight: "1px solid gray", borderColor: this.props.theme.palette.primary.main}}></span>

                            <Button className={classes.button} color="primary" onClick={()=>this.context.router.history.push("/mojestave/statistika")}>
                              Statistika
                            </Button>
                            <span style={{borderRight: "1px solid gray", borderColor: this.props.theme.palette.primary.main}}></span>
                            <Button className={classes.button} color="primary" onClick={()=>this.context.router.history.push("/mojestave/stavneosnove")}>
                              Stavne osnove
                            </Button>
                            
                            <span style={{borderRight: "1px solid gray", borderColor: this.props.theme.palette.primary.main}}></span>
                            <Button className={classes.button} color="primary" onClick={()=>this.context.router.history.push("/mojestave/mojprofil")}>
                              Profil
                            </Button>
                            <span style={{borderRight: "1px solid gray", borderColor: this.props.theme.palette.primary.main}}></span>
                            <Button className={classes.button} color="primary" onClick={this.handleLogOut}>
                              Odjava
                            </Button>
                          </span>

                        )
                      }


                    </div>

                ):auth !== false && (

                      <Button classes={{root:classes.loginButton}} onClick={this.login}  >PRIJAVA</Button>

                  )
                }
              </Grid>
            </Grid>


          </div>
      </Hidden>
    )
  }
}

NavTopFixedBar.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = ({ auth, premiumBetsData }) => {
  return {
    auth,
    premiumBetsData
  };
};

export default connect(mapStateToProps, actions)( withStyles(style, { withTheme: true })(NavTopFixedBar))



// WEBPACK FOOTER //
// ./src/components/navs/NavTopFixedBar.js